import React, { useEffect, useState } from 'react';
import Header from "../common/Header";
import './Orders.css';
import { Link, useLocation } from "react-router-dom";
import httpService from "../../services/HttpService";
import { useNavigate } from "react-router-dom";

const Orders = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const orderMessage = location.state?.message;

    const [orders, setOrders] = useState([]);
    const [notification, setNotification] = useState(null); // State for notification

    // Fetch orders data
    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await httpService.get('/orders'); // Returns Response object
                if (!response.ok) {
                    throw new Error(`Error fetching orders: ${response.statusText}`);
                }
                const data = await response.json(); // Manually parse JSON
                setOrders(data);
            } catch (error) {
                console.error('Error fetching orders:', error);
            }
        };
        fetchOrders();
    }, []);

    // Check if "Success=true" is present in the query parameters
    useEffect(() => {
        const success = new URLSearchParams(location.search).get('Success') === 'true';

        if (success) {
            setNotification(orderMessage ? orderMessage :
                'Ваш заказ успешно оформлен, служба поддержки свяжется с вами для согласования даты и времени доставки');

            // Clean the query parameters from the URL
            window.history.replaceState({}, document.title, window.location.pathname);

            // Remove notification after 3 seconds
            setTimeout(() => setNotification(null), 3000);
        }
    }, [location]);

    const mapOrderStatus = (status) => {
        switch (status) {
            case 'pending':
                return 'В обработке';
            case 'delivery':
                return 'В пути';
            case 'success':
                return 'Доставлен';
            default:
                return status;
        }
    };

    return (
        <>
            <Header />
            <main className="orders-main">
                {/* Display notification */}
                {notification && (
                    <div className="notification">
                        {notification}
                    </div>
                )}

                <div className="orders-title">Ваши заказы</div>
                {orders.length === 0 ? (
                    <p>У вас пока нет заказов</p>
                ) : (
                    <div className="orders-container">
                        {orders.map((order) => (
                            <div
                                key={order.id}
                                className="order-item"
                                onClick={(e) => {
                                    if (!e.target.closest(".refund-button")) {
                                        navigate(`/order/${order.id}`);
                                    }
                                }}
                            >
                                <div className="order-status bold">
                                    #{order.id} Статус: {mapOrderStatus(order.status)}
                                </div>

                                <div className="order-details">
                                    <p>{order.address.street}, {order.address.house}</p>
                                    <p>{order.date} {order.time}</p>
                                </div>

                                <div className="order-products">
                                    {order.products.map((product, index) => (
                                        <Link key={index}>
                                            <img
                                                src={product.main_image.link}
                                                alt={product.name}
                                                className="order-product-image"
                                            />
                                        </Link>
                                    ))}
                                </div>

                                <div className="order-amount bold">
                                    <div>Сумма заказа {order.amount} &#8381;</div>
                                    <button
                                        className="refund-button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/refund/${order.id}`);
                                        }}
                                    >
                                        Оформить возврат
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </main>
        </>
    );
};

export default Orders;